import { render } from "./ContextMenu.vue?vue&type=template&id=2cd1f2a4"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=2cd1f2a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContextMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cd1f2a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd1f2a4', __exports__)) {
    api.reload('2cd1f2a4', __exports__)
  }
  
  module.hot.accept("./ContextMenu.vue?vue&type=template&id=2cd1f2a4", () => {
    api.rerender('2cd1f2a4', render)
  })

}


export default __exports__